import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "The Language Structure",
description: "Understand the main structural elements of a Freon language definition, including models, model units, concepts, expression concepts, binary expression concepts, limited concepts, and interfaces.",
tags: [ "language structure", "metamodel", "model units", "concepts", "expression concepts", "binary expressions", "limited concepts", "interfaces", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T18:57:06.823Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};